
import { A2AAgent } from '../types';
import { specializedAgents as _specializedAgents } from './specializedAgents';
import { recruitingAgents as _recruitingAgents } from './recruitingAgents';
import { executiveAgents } from './executiveAgents';
import { emailAgents as _emailAgents } from './emailAgents';

export const specializedAgents = _specializedAgents;
export const recruitingAgents = _recruitingAgents;
export const emailAgents = _emailAgents;

// Enhanced comprehensive agent registry with full hierarchy
export const availableAgents: A2AAgent[] = [
  // Central Orchestrator (Tier 0) - BrigAI from executive agents
  ...executiveAgents,
  
  // Core Specialists (Tier 1)
  ...recruitingAgents,
  ...specializedAgents,
  
  // Email Agents (Tier 2-3) - includes email orchestrator
  ...emailAgents,
];

export const findAgentById = (agentId: string): A2AAgent | undefined => {
  return availableAgents.find(agent => agent.id === agentId);
};

export const findAgentForCapability = (capability: string): A2AAgent | undefined => {
  return availableAgents.find(agent => 
    agent.isAvailable && agent.capabilities.includes(capability)
  );
};

export const getAgentsByCategory = (category: string): A2AAgent[] => {
  return availableAgents.filter(agent => agent.category === category && agent.isAvailable);
};

export const getAgentsByTier = (tier: 'executive' | 'recruiting' | 'specialized'): A2AAgent[] => {
  return availableAgents.filter(agent => agent.category === tier && agent.isAvailable);
};
